<template>
    <div class="table-responsive">
        <table class="table table-hover table-dark">
            <tbody>
                <template v-for="product in filteredProducts" :key="'p-' + product.id">
                    <tr class="product-header">
                        <td colspan="4" class="ps-3">
                            <strong class="text-primary">{{ product.title }}</strong>
                            <svg v-if="product.is_popular" class="popular-icon ms-2" width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g fill="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#ffc107"/><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#ffc107" opacity=".5"/></g></svg>
                            <small class="text-muted d-block">{{ product.description }}</small>
                        </td>
                    </tr>
                    <tr v-for="item in getAvailableItems(product)" :key="'i-' + item.id" class="item-row">
                        <td class="ps-3 ps-md-5"></td>
                        <td>{{ item.name }} <small class="text-muted">({{ item.row_limit.toLocaleString() }} rows)</small></td>
                        <td class="text-end">
                            <span class="fw-bold">${{ item.price }}</span>
                            <small v-if="toRub(item.price)" class="d-block text-muted">~{{ toRub(item.price) }} ₽</small>
                        </td>
                        <td class="text-end pe-4 text-nowrap">
                            <button
                                v-if="buyable"
                                class="btn btn-xs btn-primary"
                                @click="$emit('buy', product, item)"
                            >
                                Buy
                            </button>
                            <router-link
                                v-else
                                :to="{path: '/datasets', query: {buy: item.id}}"
                                class="btn btn-xs btn-primary"
                            >
                                Buy
                            </router-link>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        products: {
            type: Array,
            default: () => []
        },
        popularOnly: {
            type: Boolean,
            default: false
        },
        buyable: {
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: 0
        }
    },
    computed: {
        rubRate() {
            return this.$state.rubRate
        },
        filteredProducts() {
            let result = this.products.filter(product => {
                return product.items.some(item => item.row_limit <= product.available_count)
            })
            if (this.popularOnly) {
                result = result.filter(p => p.is_popular)
            }
            if (this.limit > 0) {
                result = result.slice(0, this.limit)
            }
            return result
        }
    },
    methods: {
        getAvailableItems(product) {
            return product.items.filter(item => item.row_limit <= product.available_count)
        },
        toRub(usd) {
            if (!this.rubRate || !usd) return ''
            const rub = usd * this.rubRate
            if (rub >= 100) return Math.ceil(rub / 100) * 100
            return Math.round(rub)
        },
    }
}
</script>

<style scoped>
.product-header {
    background-color: rgba(0, 212, 170, 0.1) !important;
}
.product-header td {
    border-bottom: none;
    font-size: 1.1rem;
}
.product-header small {
    font-size: 0.95rem;
}
.item-row td {
    font-size: 1.05rem;
}
.btn-xs {
    padding: 0.25rem 0.6rem;
    font-size: 0.85rem;
}
</style>
